import { useQuery } from '@tanstack/react-query';

import { newsDetailQuery, newsListQuery } from './newsQueries';

export const useNewsList = (page = 1, pageSize = 12) => useQuery(newsListQuery(page, pageSize));

export const useNewsArticle = (slug: string) =>
  useQuery({ ...newsDetailQuery(slug), enabled: !!slug });
